(() => {
  const initialiseComparison = (root) => {
    if (!root || root.dataset.cityColourReady === 'true') return;
    root.dataset.cityColourReady = 'true';

    const cards = Array.from(root.querySelectorAll('[data-colour-card]'));
    const familyButtons = Array.from(root.querySelectorAll('[data-colour-family]'));
    const searchInput = root.querySelector('[data-colour-search]');
    const brandSelect = root.querySelector('[data-colour-brand]');
    const effectSelect = root.querySelector('[data-colour-effect]');
    const availabilitySelect = root.querySelector('[data-colour-availability]');
    const status = root.querySelector('[data-colour-status]');
    const empty = root.querySelector('[data-colour-empty]');
    const clearButtons = Array.from(root.querySelectorAll('[data-colour-clear]'));
    const filterToggle = root.querySelector('[data-colour-filter-toggle]');
    const secondaryFilters = root.querySelector('[data-colour-secondary-filters]');
    let selectedFamily = 'All';

    const normalise = (value) => (value || '').trim().toLocaleLowerCase();

    const applyFilters = () => {
      const query = normalise(searchInput?.value);
      const selectedBrand = brandSelect?.value || 'All';
      const selectedEffect = effectSelect?.value || 'All';
      const selectedAvailability = availabilitySelect?.value || 'All';
      const visibleProducts = new Set();
      let visible = 0;

      cards.forEach((card) => {
        const familyMatch = selectedFamily === 'All' || card.dataset.family === selectedFamily;
        const brandMatch = selectedBrand === 'All' || card.dataset.brand === selectedBrand;
        const effectMatch = selectedEffect === 'All' || card.dataset.effect === selectedEffect;
        const availabilityMatch = selectedAvailability === 'All'
          || (selectedAvailability === 'plano-available' && card.dataset.availability.includes('plano'))
          || (selectedAvailability === 'rx-available' && card.dataset.availability.includes('rx'));
        const searchMatch = !query || normalise(card.dataset.search).includes(query);
        const show = familyMatch && brandMatch && effectMatch && availabilityMatch && searchMatch;

        card.hidden = !show;
        if (show) {
          visible += 1;
          visibleProducts.add(card.dataset.product);
        }
      });

      if (status) status.textContent = `Showing ${visible} colour${visible === 1 ? '' : 's'} across ${visibleProducts.size} product${visibleProducts.size === 1 ? '' : 's'}`;
      if (empty) empty.hidden = visible !== 0;
    };

    const setFamily = (family) => {
      selectedFamily = family;
      familyButtons.forEach((button) => {
        const active = button.dataset.colourFamily === family;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', String(active));
      });
    };

    const clearFilters = () => {
      setFamily('All');
      if (searchInput) searchInput.value = '';
      if (brandSelect) brandSelect.value = 'All';
      if (effectSelect) effectSelect.value = 'All';
      if (availabilitySelect) availabilitySelect.value = 'All';
      applyFilters();
      searchInput?.focus({ preventScroll: true });
    };

    familyButtons.forEach((button) => button.addEventListener('click', () => {
      setFamily(button.dataset.colourFamily);
      applyFilters();
    }));
    [brandSelect, effectSelect, availabilitySelect].forEach((select) => select?.addEventListener('change', applyFilters));
    searchInput?.addEventListener('input', applyFilters);
    clearButtons.forEach((button) => button.addEventListener('click', clearFilters));

    filterToggle?.addEventListener('click', () => {
      const open = filterToggle.getAttribute('aria-expanded') !== 'true';
      filterToggle.setAttribute('aria-expanded', String(open));
      secondaryFilters?.classList.toggle('is-open', open);
    });
  };

  const initialiseAll = (scope = document) => scope.querySelectorAll('[data-city-colour-comparison]').forEach(initialiseComparison);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialiseAll());
  else initialiseAll();
  document.addEventListener('shopify:section:load', (event) => initialiseAll(event.target));
})();
